import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core'
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common'
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en'

let zxcvbnInitialized = false;
function ensureZxcvbnOptionsInitialized(): void {
    const options = {
        translations: zxcvbnEnPackage.translations,
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
            ...zxcvbnEnPackage.dictionary,
        },
    }

    zxcvbnOptions.setOptions(options)

}

export type PasswordStrength = {
    score: number;
    feedback: string[];
};

export function getPasswordStrength(password: string): PasswordStrength {
    ensureZxcvbnOptionsInitialized();
    if (!password || password.length === 0) {
        return { score: 0, feedback: [] };
    }

    const result = zxcvbn(password);

    if (password.length < 10) {
        return { score: 0, feedback: [] };
    }

    if (result.score > 1 && password.length < 14) {
        return { score: 1, feedback: [] };
    }

    const feedback: string[] = [];
    if (result.feedback.warning) {
        feedback.push(result.feedback.warning);
    }
    if (result.feedback.suggestions && result.feedback.suggestions.length > 0) {
        feedback.push(...result.feedback.suggestions);
    }
    return { score: result.score, feedback };
}

export function validatePassword(newPassword: string): string[] {
    let errors: string[] = [];

    var regexpUpper = new RegExp('[A-Z]');
    var regexpLower = new RegExp('[a-z]');
    var regexpNumber = new RegExp('[0-9]');
    var regexpSpecial = new RegExp('[^A-Za-z0-9]');

    if (newPassword.length < 14) {
        errors = ([...errors, "Passwords must be at least 14 characters long"]);
    }
    let matches = 0;
    if (regexpUpper.test(newPassword)) {
        matches++;
    }
    if (regexpLower.test(newPassword)) {
        matches++;
    }
    if (regexpSpecial.test(newPassword)) {
        matches++;
    }
    if (regexpNumber.test(newPassword)) {
        matches++;
    }
    if (matches < 3) {
        errors = ([...errors, "Passwords must contain at least 3 of the following types: a lowercase letter, an uppercase letter, a number or a special character. Valid characters are: ! # £ $ % & * . , \" ` @ ^ = + - _ ? ~"]);
    }

    // Enforce strong password using zxcvbn: require maximum score (4)
    const strength = getPasswordStrength(newPassword);
    if (strength.score < 4) {
        errors = ([
            ...errors,
            "Password is too weak. Please choose a stronger password."
        ]);
    }

    return errors;
}